import * as axios from 'axios';
import { getAuthHeader } from '../utils';

// admin section
export const getBorrowerLoan = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/borrower/loan-list`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}